<template>
  <div id="tour-placement-combinations-list">
    <tour-placement-combination-group v-for="(group, index) in computed_groups"
                                      :params="group"
                                      :start_date="tour_date.attributes.date"
                                      :inheritance="inherited"
                                      :index="index"
                                      :key="index"
                                      :discount="tour_date.attributes.discount"
                                      :discount_type="tour_date.attributes.discount_type"
                                      @choose="collect_combos"
    />
  </div>
</template>

<script>
import api from '../../../store/api/api';
import _ from 'lodash';
import CombinationHelper from "../../../components/shared/CombinationHelper";
import CombinationMethods from "../../../mixins/CombinationMethods";
import TourPlacementCombinationGroup from "./TourPlacementCombinationGroup";
import DebugLog from "../../../mixins/DebugLog";
import {includes_array} from "../../../components/shared/helpers";

export default {
  components: {TourPlacementCombinationGroup},
  // extends: CombinationHelper,
  mixins: [CombinationMethods, DebugLog],
  props:{
    tour: Object,
    tourists: Object,
    tour_date: Object,
  },
  data() {
    return {
      state: 'ready',
      placement_prices: [],
      hotel_groups: [],
      groups: [],
      choosed: [],
      inherited: [],
    }
  },
  computed: {
    computed_groups(){
      // console.log('calc again');
      return this.make_groups(
          this.placement_prices,
          this.hotel_groups,
          this.tourists.adults,
          this.tourists.kids,
          this.tour.baby_age,
      );
    },
  },
  watch:{
    tour_date(){
      // console.log('tour date changed')
      this.get_tour_placement_prices();
      this.getHotelGroups();
    },
    tourists(){
      // console.log('tourists changed')
      this.get_tour_placement_prices();
      this.getHotelGroups();
    },
  },
  beforeMount(){
    this.get_tour_placement_prices();
    this.getHotelGroups();
  },

  methods: {
    collect_combos(combo, group){
      // combo - выбранная комбинация
      // group - группа в которой была выбрана комбинация
      // console.log("CHOOOOSE!!!", combo);
      // группы-наследники от выбранной группы
      let inh_groups = this.inherited_from(group);

      if (inh_groups.length > 0) {
        // для каждой группы-наследника
        _.each(inh_groups, (inh_group)=>{
          let equal_combo, combo_group;
          // найти группу (вместе с комбинациями), в которую наследовать
          combo_group = this.find_combinations_for_group(inh_group, this.computed_groups);

          if (combo_group) {
            // найти эквивалентную комбинацию
            equal_combo = this.find_equal_combo(combo, combo_group.combinations);
            // сохранить все в объекте
            if (equal_combo) {
              this.add_or_replace_inherited_combo(equal_combo, inh_group);
            }
          }
        });

      }
      this.add_or_replace_choosed_combo(combo, group);
      this.$emit('update_choosed_combination', this.choosed)
    },

    add_or_replace_choosed_combo(combo, group){
      let index = _.findIndex(this.choosed, {group_id: group.id});
      let obj = {
        group_id: group.id,
        combo: combo,
      };
      if (index >= 0) {
        this.choosed.splice(index, 1, obj);
      } else {
        this.choosed.push(obj);
      }
    },

    add_or_replace_inherited_combo(combo, group){
      // console.log('INHERITED: ', group.id);
      let index = _.findIndex(this.inherited, {group_id: group.id});
      // console.log('INHERITED: ', index, group.id);
      let obj = {
        group_id: group.id,
        combo: combo,
      };
      if (index >= 0) {
        this.inherited.splice(index, 1, obj);
      } else {
        this.inherited.push(obj);
      }
    },

    inherited_from(group){
      let inh_groups = [];
      _.each(this.hotel_groups, (el)=>{
        if (el && el.inherited === true && Number(el.hotel_group_id) === Number(group.id)) {
          inh_groups.push(el);
        }
      });
      return inh_groups;
    },

    getHotelGroups(){
      let vc = this;
      api.getHotelGroups(data => {
        // console.log('getHotelGroups',data);

        vc.$set(vc, 'hotel_groups', _.map(data.data, (el)=>{ return el.attributes }));
      }, {tour_date_id: this.tour_date.id});
    },

    // Получаем список подходящих размещений (tour_placement_price)
    // с учетом параметров в booking
    get_tour_placement_prices(booking) {
      // this.$set(this, 'localBooking', booking.attributes);
      let vc = this;
      let url = '/tour_placement_prices/search';
      let search_params = {
        tour_date_id: vc.tour_date.id,
        adults: vc.tourists.adults,
        kids: vc.tourists.kids.length,
        ages: vc.tourists.kids,
        all: true,
      };

      $.ajax({
            url: url,
            data: search_params,
            dataType: 'json',
            type: 'GET'
          })
          .done(function (data) {
            // console.log('updated tour_placement_prices:', data.data);
            vc.$set(vc, 'placement_prices', data.data);
          })
          .fail(function (jqXHR, textStatus) {
            var errors = jqXHR.responseJSON;
            // console.log(errors);
            alert('Не удалось загрузить размещения.', url);
          })
    },
  }
}
</script>